import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * Label component
 * @param {React.LabelHTMLAttributes<HTMLLabelElement>} props
 * @returns {JSX.Element}
 */
const Label = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <label
      ref={ref}
      className={cn('text-label font-medium text-ink peer-disabled:opacity-60', className)}
      {...props}
    />
  )
})
Label.displayName = 'Label'

export { Label }
